import { render, staticRenderFns } from "./ClosedIcon.vue?vue&type=template&id=ea4fef7a&"
import script from "./ClosedIcon.vue?vue&type=script&lang=js&"
export * from "./ClosedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports